import React, { useEffect, useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import { PHONE_ERR_MSG } from 'constants/validMsg';
import { funcType, phoneType, stringType } from 'containers/pages/contacts/types';
import './InputPhoneLib.css';

/**
 * @component InputPhoneLib
 * A phone‐number input that validates for any country code (min. 10 digits).
 */
function InputPhoneLib(props) {
  const [error, setError] = useState({ isError: false, message: '' });
  const [value, setValue] = useState('');

  const onChangePhone = (phone, data, e) => {
    // keep the input controlled
    setValue(phone);

    // strip all non‐digits
    const digits = phone.replace(/\D/g, '');

    // empty input → clear errors
    if (!digits) {
      props.onChangeValid(props.name, false, '');
      setError({ isError: false, message: '' });
      return;
    }

    // require at least 10 digits total
    if (digits.length >= 11) {
      const number = digits.slice(data.dialCode.length);
      const payload = {
        number,
        dialCode: data.dialCode,
        countryCode: data.countryCode,
        ext: '',
      };

      // fire parent handlers
      e.target.name = props.name;
      props.onChange(e, payload);
      props.onChangeValid(props.name, false, '');
      setError({ isError: false, message: '' });
    } else {
      props.onChangeValid(props.name, true, PHONE_ERR_MSG);
      setError({ isError: true, message: PHONE_ERR_MSG });
    }
  };

  useEffect(() => {
    // when props.value changes, reconstruct the input string
    const { dialCode, number, ext } = props.value || {};
    let formatted = '';
    if (dialCode && number) {
      formatted = `${dialCode}${number}`;
      if (ext) formatted += ` Ext-${ext}`;
    }
    setValue(formatted);
  }, [props.value]);

  return (
    <section className="main">
      <PhoneInput
      specialLabel={props.label}
        country="ca"
        preferredCountries={['ca', 'us']}
        value={value}
        autoFormat
        prefix=""
        countryCodeEditable={false}
        placeholder=""
        priority={{ ca: 0, us: 1 }}
        isValid={!error.isError}
        defaultErrorMessage={PHONE_ERR_MSG}
        enableLongNumbers={26}
        onChange={onChangePhone}
      />
      {error.isError && (
        <p className="input_phone_error_messsage">{error.message}</p>
      )}
    </section>
  );
}

InputPhoneLib.propTypes = {
  label: stringType,
  name: stringType,
  onChange: funcType,
  onChangeValid: funcType,
  value: phoneType,
};

export default InputPhoneLib;
